export default "__VITE_ASSET__CmouOh3S__"